import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Text } from '@travel-frontend/core';
import { forwardRef } from 'react';
import { Badge } from '../../primitives/Alert/components/Badge.js';
import { Container } from '../../primitives/Alert/components/Container.js';
import { Content } from '../../primitives/Alert/components/Content.js';
import { Controls } from '../../primitives/Alert/components/Controls.js';
import { getIcon } from '../../primitives/Alert/utlis/getIcon.js';
const AlertUI = ({
  variant = 'info',
  controls,
  caption,
  withIcon = true,
  children,
  ...restProps
}, ref) => {
  return _jsxs(Container, {
    ref: ref,
    variant: variant,
    ...restProps,
    children: [withIcon && _jsx(Badge, {
      children: getIcon(variant)
    }), _jsxs(Content, {
      children: [_jsxs("div", {
        children: [caption && _jsx(Text, {
          display: "block",
          preset: "paragraphMediumBold",
          children: caption
        }), children && _jsx(Text, {
          display: "block",
          preset: "paragraphMedium",
          children: children
        })]
      }), controls && _jsx(Controls, {
        children: controls
      })]
    })]
  });
};
export const Alert = /*#__PURE__*/_styled(forwardRef(AlertUI), {
  label: 'Alert',
  target: "ejpqrg80"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkFsZXJ0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNHIiwiZmlsZSI6IkFsZXJ0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsganN4IGFzIF9qc3gsIGpzeHMgYXMgX2pzeHMgfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3QvanN4LXJ1bnRpbWVcIjtcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IFRleHQgfSBmcm9tICdAdHJhdmVsLWZyb250ZW5kL2NvcmUnO1xuaW1wb3J0IHsgZm9yd2FyZFJlZiB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IEJhZGdlIH0gZnJvbSAnLi4vLi4vcHJpbWl0aXZlcy9BbGVydC9jb21wb25lbnRzL0JhZGdlLmpzJztcbmltcG9ydCB7IENvbnRhaW5lciB9IGZyb20gJy4uLy4uL3ByaW1pdGl2ZXMvQWxlcnQvY29tcG9uZW50cy9Db250YWluZXIuanMnO1xuaW1wb3J0IHsgQ29udGVudCB9IGZyb20gJy4uLy4uL3ByaW1pdGl2ZXMvQWxlcnQvY29tcG9uZW50cy9Db250ZW50LmpzJztcbmltcG9ydCB7IENvbnRyb2xzIH0gZnJvbSAnLi4vLi4vcHJpbWl0aXZlcy9BbGVydC9jb21wb25lbnRzL0NvbnRyb2xzLmpzJztcbmltcG9ydCB7IGdldEljb24gfSBmcm9tICcuLi8uLi9wcmltaXRpdmVzL0FsZXJ0L3V0bGlzL2dldEljb24uanMnO1xuY29uc3QgQWxlcnRVSSA9ICh7IHZhcmlhbnQgPSAnaW5mbycsIGNvbnRyb2xzLCBjYXB0aW9uLCB3aXRoSWNvbiA9IHRydWUsIGNoaWxkcmVuLCAuLi5yZXN0UHJvcHMgfSwgcmVmKSA9PiB7XG4gICAgcmV0dXJuIChfanN4cyhDb250YWluZXIsIHsgcmVmOiByZWYsIHZhcmlhbnQ6IHZhcmlhbnQsIC4uLnJlc3RQcm9wcywgY2hpbGRyZW46IFt3aXRoSWNvbiAmJiBfanN4KEJhZGdlLCB7IGNoaWxkcmVuOiBnZXRJY29uKHZhcmlhbnQpIH0pLCBfanN4cyhDb250ZW50LCB7IGNoaWxkcmVuOiBbX2pzeHMoXCJkaXZcIiwgeyBjaGlsZHJlbjogW2NhcHRpb24gJiYgKF9qc3goVGV4dCwgeyBkaXNwbGF5OiBcImJsb2NrXCIsIHByZXNldDogXCJwYXJhZ3JhcGhNZWRpdW1Cb2xkXCIsIGNoaWxkcmVuOiBjYXB0aW9uIH0pKSwgY2hpbGRyZW4gJiYgKF9qc3goVGV4dCwgeyBkaXNwbGF5OiBcImJsb2NrXCIsIHByZXNldDogXCJwYXJhZ3JhcGhNZWRpdW1cIiwgY2hpbGRyZW46IGNoaWxkcmVuIH0pKV0gfSksIGNvbnRyb2xzICYmIF9qc3goQ29udHJvbHMsIHsgY2hpbGRyZW46IGNvbnRyb2xzIH0pXSB9KV0gfSkpO1xufTtcbmV4cG9ydCBjb25zdCBBbGVydCA9IHN0eWxlZChmb3J3YXJkUmVmKEFsZXJ0VUkpLCB7XG4gICAgbGFiZWw6ICdBbGVydCcsXG59KSBgYDtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPUFsZXJ0LmpzLm1hcCJdfQ== */");